import { useContext } from 'react';
import { NotificationContext, NotificationContextValue } from '../contexts/NotificationContextDef';

export function useNotifications(): NotificationContextValue {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotifications must be used within a NotificationProvider');
  }
  return context;
}
